// Vendor libraries
import * as Highcharts from 'highcharts/highstock';
import addNoData from 'highcharts/modules/no-data-to-display';
// Show no data message when there is no data
addNoData(Highcharts);
export default Highcharts;
